module.exports = __webpack_public_path__ + "img/logo.header.9cc31415.png";